import { Injectable } from '@angular/core';
import {ActivatedRoute, Params, Router, UrlTree} from '@angular/router';
import {EmbedModeService} from "../../feature/services/embed-mode.service";
import {HttpParams} from "@angular/common/http";
import {TestRunService} from "../../feature/services/test-run.service";

@Injectable({
  providedIn: 'root',
})
export class UrlTreeHelper {
  constructor(private router: Router,
              private embedModeService: EmbedModeService,
              private testRunService: TestRunService) {}

  /**
   * Generate a UrlTree based on a prefix or suffix and optional query parameters.
   *
   * @param basePath - The base path of the URL (e.g., 'dashboard').
   * @param options - Options containing prefix, suffix
   * @returns A UrlTree object representing the generated URL.
   */
  generateUrlTree(basePath: string, options: {
    prefix?: string;
    suffix?: string;
  }): UrlTree {
    let path = basePath;

    if (options.prefix) {
      path = `${options.prefix}/${path}`;
    }

    if (options.suffix) {
      path = `${path}/${options.suffix}`;
    }

    let queryParams = {} as any;
    if(this.embedModeService.isEmbedModeEnabled()) {
      queryParams.embedMode = this.embedModeService.getEmbedMode();
    }
    if(this.testRunService.isTestRun()) {
      queryParams = {
        testRun: this.testRunService.isTestRun(),
      }
    }

    return this.router.createUrlTree([path], { queryParams, queryParamsHandling: "merge" });
  }
}
